import React from 'react';
import PropTypes from 'prop-types';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import ProductsListFilters from './ProductsListFilters';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import AccountField from 'components/field/AccountField';
import TextField from 'components/field/TextField';
import listQueryFilter from 'components/hoc/listQueryFilter';
import theme from 'theme/theme';
import { deleteProduct } from 'store/actions/products/deleteProducts';
import { fetchProducts } from 'store/actions/products/fetchProducts';
import authHelper from 'helpers/auth';

const ProductsList = (props) => {
    const {
        actionType,
        location,
        resource,
        updateQuery,
    } = props;

    const isProvider = authHelper.isProvider();
    const isAdmin = authHelper.isAdmin();

    const link = isProvider ? 'occupancy' : 'show';

    return (
        <div>
            <ProductsListFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ResourceList
                action={ fetchProducts }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table
                    colorToggle={ {
                        condition: false,
                        color: theme.palette.gray,
                        key: 'enabled',
                    } }
                    link={ link }
                >
                    <TextField
                        { ...props }
                        column={ {
                            sortable: true,
                            width: '60%',
                        } }
                        label='resources.products.fields.title'
                        maxCharacters={ 100 }
                        source='title'
                    />

                    { isAdmin && (
                        <AccountField
                            column={ {
                                align: 'center',
                                link: false,
                                width: '25%',
                            } }
                            display='name'
                            label='resources.products.fields.provider_id'
                            source='provider_id'
                        />
                    ) }

                    <DropDownActionsMenu
                        column={ {
                            align: 'center',
                            link: false,
                            width: '10%',
                        } }
                        resource={ resource }
                    >
                        <EditAction />

                        <DeleteAction action={ deleteProduct } />
                    </DropDownActionsMenu>
                </Table>
            </ResourceList>
        </div>
    );
};

ProductsList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    options: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

export default listQueryFilter(ProductsList);



// WEBPACK FOOTER //
// ./src/pages/products/list/ProductsList.js